import { searchPhraseDictionary } from "@core/global/global-country-dictionary";

const CategoryContainer = ({ suggestions, dropdownOptions, searchKeyLabel, setSearchKeyLabel, setSelectedData, searchButtonClicked, removeSearchTab, setIsMatchTypeExact }) => {
  const allSuggestion = suggestions?.[searchKeyLabel?.label];
  const isCategoryAvailable = (suggestion) => {
    const suggestionValue = suggestion?.is_chemical || suggestion?.category_name?.toLowerCase() === "chemical" ? searchPhraseDictionary.chemical_description : suggestion?.key;
    const suggestionLabel = suggestion?.category_name?.toLowerCase();
    return (dropdownOptions ?? []).some((option) => (!!suggestionValue && option?.value === suggestionValue) || (!!suggestionLabel && option?.label?.toLowerCase() === suggestionLabel));
  };
  const filteredSuggestions = allSuggestion?.filter((suggestion) => suggestion?.category_name !== searchKeyLabel?.label && isCategoryAvailable(suggestion));
  return (
    <div className="tw-absolute tw-top-[85px] tw-z-10 tw-flex tw-items-center">
      <div className="tw-bg-white tw-rounded-xl tw-p-3 tw-w-[600px] tw-max-h-[300px] tw-overflow-y-auto tw-shadow-autoSuggest">
        <div className="tw-flex tw-flex-col tw-gap-2.5">
          <div className="tw-text-gray-900 tw-text-xs">Select a category</div>
          <div className="tw-flex tw-gap-x-2 tw-gap-y-4 tw-flex-wrap">
            {dropdownOptions?.map(
              (suggestion) =>
                suggestion.value !== searchPhraseDictionary.entire_bill_of_lading && (
                  <div key={suggestion.value} className="tw-cursor-pointer tw-px-2 tw-py-1 tw-border tw-rounded-[54px] tw-bg-white tw-flex tw-items-center tw-gap-1 tw-text-sm tw-text-gray-900 tw-border-gray-200 tw-shadow-autoSuggestPill" onClick={() => setSearchKeyLabel(suggestion)}>
                    <div className="tw-w-4 tw-h-4 tw-rounded-lg tw-px-1 tw-text-xs tw-text-white" style={{ backgroundColor: suggestion?.pillColor }}>
                      {suggestion?.label?.substring(0, 1)?.toUpperCase()}
                    </div>
                    <div>{suggestion?.label}</div>
                  </div>
                )
            )}
          </div>
          {filteredSuggestions?.length > 0 && (
            <>
              <div className="tw-border-t tw-border-gray-200" />
              <div className="tw-text-gray-900 tw-text-xs">Recent Search</div>
              <div className="tw-flex tw-gap-x-2 tw-gap-y-4 tw-flex-wrap">
                {filteredSuggestions.map((suggestion) => (
                  <div
                    key={suggestion?.user_search + suggestion?.category_name}
                    className="tw-cursor-pointer tw-px-2 tw-py-1 tw-border tw-border-gray-200 tw-rounded-[54px] tw-shadow-autoSuggestPill tw-bg-white tw-flex tw-items-center tw-gap-1 tw-text-sm tw-text-gray-900"
                    onClick={(e) => {
                      setIsMatchTypeExact(suggestion.queryType);
                      setSearchKeyLabel({ label: suggestion?.category_name, value: suggestion?.category_name?.toLowerCase() === "chemical" ? "chemical_description" : suggestion?.key });
                      setSelectedData(suggestion?.search.map((item) => ({ label: item, value: item })));
                      searchButtonClicked(e, suggestion, suggestion.is_chemical);
                    }}>
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#1c1b1f">
                        <path d="M813-144 574-383q-30 22-66 34.5T432-336q-37 0-70-10.5T300-376l53-53q18 9 37.5 15t41.5 6q70 0 119-49t49-119q0-70-49-119t-119-49q-70 0-119 49t-49 119l53-51 51 51-136 136L96-576l51-51 45 46q2-98 71.5-166.5T432-816q100 0 170 70t70 170q0 40-12.5 76T625-434l239 239-51 51Z" />
                      </svg>
                    </div>
                    <div>
                      {suggestion.category_name} - {suggestion?.search.map((val) => (val.includes("|") ? val.split("|")[0] : val)).join(", ")}
                    </div>
                    <div onClick={(event) => removeSearchTab(event, suggestion)}>
                      <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#101828">
                        <path d="m291-240-51-51 189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z" />
                      </svg>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default CategoryContainer;
